import React from "react";
import { Tag } from "antd";
import moment from "moment";

export const tableColumns = {
  getDedicatedNumberColumns: () => [
    {
      title: "Number",
      dataIndex: "number",
      width: 150,
      render: text => <span>{text || "-"}</span>
    },
    {
      title: "Date",
      dataIndex: "datetime",
      width: 150,
      render: date => <span>{date ? moment(date).format("DD/MM/YYYY") : "-"}</span>
    },
    {
      title: "Service Type",
      dataIndex: "serviceType",
      width: 120,
      render: serviceType => (serviceType ? <Tag color="blue">{serviceType.toUpperCase()}</Tag> : <span>-</span>)
    },
    {
      title: "Amount (GST Excluded)",
      dataIndex: "amount",
      width: 100,
      render: (amount, record) => (
        <span>
          {record.countryCode ? record.countryCode.toUpperCase() : ""}D {!isNaN(Number(amount)) && amount != null ? Number(amount).toFixed(2) : "-"}
        </span>
      )
    },
    {
      title: "Payment Mode",
      dataIndex: "payMode",
      width: 130,
      render: paymentMode => (paymentMode ? <Tag color="green">{paymentMode.toUpperCase()}</Tag> : <span>-</span>)
    },
    {
      title: "Invoice Status",
      dataIndex: "invoiceStatus",
      width: 120,
      render: invoiceStatus => <>{invoiceStatus ? "Completed" : "Pending"}</>
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      width: 120,
      render: createdBy => <span>{createdBy || "-"}</span>
    }
  ],

  getAdminColumns: () => [
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 100,
      render: text => <div style={{ fontSize: "12px" }}>{moment(text).format("DD/MM/YYYY HH:mm")}</div>
    },
    {
      title: "Total (SMS/MMS)",
      key: "sms_mms_price",
      width: 110,
      render: (_, record) => (
        <div style={{ fontSize: "12px" }}>
          SMS: {record.totalSmsCount || 0} <br />
          MMS: {record.totalMmsCount || 0}
        </div>
      )
    },
    {
      title: "Rate (SMS/MMS)",
      key: "rates",
      width: 110,
      render: (_, record) => (
        <div style={{ fontSize: "12px" }}>
          {(record.centsPerSMS || 0).toFixed(2)}¢ / {(record.centsPerMMS || 0).toFixed(2)}¢
        </div>
      )
    },
    {
      title: "Amount (GST Excluded)",
      dataIndex: "totalAmount",
      key: "amount",
      width: 100,
      render: (text, record) => (
        <div style={{ fontSize: "12px", fontWeight: "500" }}>
          {record.currency?.code?.toUpperCase() || ""} {(text / 100).toFixed(2)}
        </div>
      )
    },
    {
      title: "Payment Mode",
      dataIndex: "paymentMode",
      key: "payment_mode",
      width: 120,
      render: text => {
        if (!text) return <span style={{ fontSize: "12px" }}>-</span>;

        const mode = text.toLowerCase();
        let color = "gray";

        if (mode === "reward") {
          color = "gold";
        } else if (mode === "stripe") {
          color = "blue";
        }

        return (
          <Tag color={color} style={{ fontSize: "11px" }}>
            {text.toUpperCase()}
          </Tag>
        );
      }
    },
    {
      title: "Invoicing Type",
      dataIndex: "invoiceMethod",
      key: "invoice_method",
      width: 120,
      render: text => {
        if (!text) return <span style={{ fontSize: "12px" }}>-</span>;

        const method = text.toLowerCase();
        const isUsage = method === "usage" || method === "usages";
        const isCredit = method === "credit" || method === "credits";

        if (isUsage || isCredit) {
          return (
            <Tag color={isUsage ? "orange" : "green"} style={{ fontSize: "11px" }}>
              {isUsage ? "USAGE" : "CREDIT"}
            </Tag>
          );
        }

        return (
          <Tag color="default" style={{ fontSize: "11px" }}>
            {text.toUpperCase()}
          </Tag>
        );
      }
    },
    {
      title: "Invoice Status",
      dataIndex: "invoiceStatus",
      key: "invoiceStatus",
      width: 120,
      render: invoiceStatus => <>{invoiceStatus ? "Completed" : "Pending"}</>
    }
  ]
};
